import React from "react";
import { graphql } from "gatsby";
import g from "glamorous";
import styled from "@emotion/styled";
import { css } from "glamor";
import Layout from "../components/layout";
import ContactSidebar from "../components/ContactSidebar-en";
import AdresseSidebar from "../components/AdresseSidebar-en";
import Accordion from "../components/Accordion-en";
import AvantApresBlock from "../components/AvantApresBlock-en";
import KeybodyBlock from "../components/KeybodyBlock-en";
import VideoBlock from "../components/VideoBlock-en";
import NewsBlock from "../components/NewsBlock-en";
import ASavoir from "../components/ASavoir-en";
import Bio from "../components/Bio-en";
import BioV2 from "../components/Bio-v2-en";
import Menu from "../components/Menu-en";
import Footer from "../components/Footer-en";
import Social from "../components/Social-en";
import { FaHome } from "react-icons/fa";
import Img from "gatsby-image";
import { Link } from "gatsby";
import { Container, Row, Col } from "glamorous-grid";
import { Helmet } from "react-helmet";

export default function Template({ data }) {
  const { markdownRemark } = data; // data.markdownRemark holds our post data

  const { frontmatter, html } = markdownRemark;

  const Wrapper = g.div({
    maxWidth: `1000px`,
    margin: `0 auto 2.5em`,
  });

  const Tag = g.div({
    textAlign: `center`,
    color: `black`,
    fontSize: `.8em`,
    fontWeight: `400`,
    marginTop: `2.4em`,
    textTransform: `uppercase`,
    letterSpacing: `.08em`,
    "@media(max-width: 767px)": {
      fontSize: `.85em`,
      marginTop: `1.6em`,
    },
  });

  const Title = g.h1({
    textAlign: `center`,
    fontSize: `36px`,
    color: `#3c4d68`,
    maxWidth: `700px`,
    margin: `.1em auto .6em`,
    fontVariant: `none`,
    fontWeight: `600`,
    letterSpacing: `.01em`,
    lineHeight: `49px`,
    "@media(max-width: 767px)": {
      fontSize: `25px`,
      lineHeight: `32px`,
    },
  });

  const Tags = g.div({
    marginBottom: `30px`,
    textAlign: `right`,
  });

  const TagsItem = g.span({
    display: `inline-block`,
    textTransform: `capitalize`,
    "&::after": {
      color: `#333`,
      paddingRight: `3px`,
    },
    "&::last-of-type": {
      color: `red`,
    },
    ":hover": {
      textDecoration: `underline`,
    },
    ":focus": {},
  });

  const Breadcrumb = g.ul({
    fontSize: `13px`,
    lineHeight: `20px`,
    marginLeft: `0 !important`,
    marginTop: `0`,
    marginBottom: `10px !important`,
    fontWeight: `500`,
    letterSpacing: `.015em`,
  });

  const BreadcrumbItem = g.li({
    display: `inline`,
    "&:first-of-type": {
      "&::before": {
        content: `none`,
      },
    },
    "&::before": {
      content: `/`,
      padding: `0 .5em`,
    },
  });

  const TranslationBlock = g.div({
    fontSize: `.9em`,
    margin: `2.5em 0`,
    lineHeight: `1.55em`,
    fontStyle: `italic`,
  });

  const cssBreadcrumbLink = css({
    color: `#3c4d68`,
    borderBottom: `none`,
  });

  css.global(".gatsby-resp-image-figcaption", {
    textAlign: "center",
    fontStyle: `italic`,
    fontSize: `.85em`,
    lineHeight: `1.45em`,
    marginTop: `.5em`,
  });

  css.insert('.tagsitem:after { content: ","; padding-right: 5px;  }');
  css.insert('.tagsitem:last-of-type:after { content: ""  }');

  const WrapperV2 = styled.div`
    max-width: 1200px;
    margin: 3em auto 2.5em;
    background-color: white;
    border-radius: 25px 25px 0 0;
    border: 1px solid rgba(73, 105, 126, 0.08);
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
    @media only screen and (max-width: 768px) {
      width: 100%;
    }
  `;

  const BreadcrumbV2 = styled.ul`
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    font-weight: 500;
    letter-spacing: 0.015em;
  `;

  const TitleV2 = styled.h1`
    font-family: SF Pro Display, SF Pro Text;
    text-align: center;
    font-size: 40px;
    color: #3c4d68;
    margin: 0.1em auto 0.6em;
    font-variant: none;
    font-weight: 600;
    letter-spacing: 0.01em;
    line-height: 45px;
    @media only screen and (max-width: 768px) {
      font-size: 31px;
      line-height: 35px;
      margin: 0 0 20px;
    }
  `;

  const Content = styled.div`
    padding: 0 40px;
    @media only screen and (max-width: 768px) {
      padding: 0 14px;
    }
  `;

  const BioWrapper = styled.div`
    display: flex;
    max-width: 1200px;
    margin: 3em auto 2.5em;
    border-radius: 25px 25px 0 0;
    @media only screen and (max-width: 768px) {
      display: none;
    }
  `;

  const BioWrapperMobile = styled.div`
    display: none;
    @media only screen and (max-width: 768px) {
      display: block;
      padding: 12px;
    }
  `;

  const TranslationBlockV2 = g.div({
    fontSize: `.9em`,
    margin: `2.5em 2em`,
    lineHeight: `1.55em`,
    fontStyle: `italic`,
  });

  return (
    <Layout>
      <g.Div id="page-wrap" margin={`0 auto`} backgroundColor={`#fcfcfc`}>
        <Helmet>
          <html lang="en" />
          <title>{frontmatter.metaTitle}</title>
          <meta name="description" content={frontmatter.metaDescription} />
          <meta
            property="og:url"
            content={`https://www.dr-kron.com${frontmatter.path}`}
          />
          <meta property="og:type" content="article" />
          <meta property="og:title" content={frontmatter.title} />
          <meta
            property="og:description"
            content={frontmatter.metaDescription}
          />
          {frontmatter.image && (
            <meta
              property="og:image"
              content={`https://www.dr-kron.com${frontmatter.image.childImageSharp.fluid.src}`}
            />
          )}
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image:width" content="800" />
          <meta property="og:image:height" content="455" />

          <meta property="og:locale" content="en_US" />
          <meta property="fb:app_id" content="402235436975681" />

          {frontmatter.pathFr !== "/" && (
            <link
              rel="alternate"
              hreflang="fr"
              href={`https://www.dr-kron.com${frontmatter.pathFr}`}
            />
          )}

          {/* Breadcrumbs for interventions */}
          {frontmatter.tags[0] !== "practice" &&
            frontmatter.tags[0] !== "news" && (
              <script type="application/ld+json">{`
        {
              "@type": "ListItem",
              "position": 1,
              "name": "${
                frontmatter.tags[0].charAt(0).toUpperCase() +
                frontmatter.tags[0].slice(1)
              }",
              "item": "https://www.dr-kron.com/${frontmatter.tags[0].replace(
                /\s+/g,
                "-",
              )}/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "${frontmatter.title}",
              "item": "https://www.dr-kron.com${frontmatter.path}"
            }]
        }
    `}</script>
            )}
          {/* Breadcrumbs for actualites */}
          {frontmatter.tags[0] === "news" && (
            <script type="application/ld+json">{`
        {
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "News",
              "item": "https://www.dr-kron.com/en/news/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "${frontmatter.title}",
              "item": "https://www.dr-kron.com${frontmatter.path}"
            }]
        }
    `}</script>
          )}
          {/* Breadcrumbs for cabinet */}
          {frontmatter.tags[0] === "practice" && (
            <script type="application/ld+json">{`
        {
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "${frontmatter.title}",
              "item": "https://www.dr-kron.com${frontmatter.path}"
            }]
        }
    `}</script>
          )}
        </Helmet>
        <Menu pathFr={frontmatter.pathFr} />

        {frontmatter.pageTemplate !== "fullwidth" && (
          <Wrapper>
            <article
              data-pagefind-body
              data-pagefind-weight={
                ["cabinet", "practice"].includes(frontmatter.tags[0])
                  ? "2.5"
                  : "5"
              }
            >
              <Container css={{ padding: `0 15px !important` }}>
                <Row>
                  <Col>
                    <div className="page-post">
                      {frontmatter.tags[0] === "practice" && <p>&nbsp;</p>}

                      {frontmatter.tags[0] !== "practice" && (
                        <Link
                          to={`/en/${frontmatter.tags[0].replace(
                            /\s+/g,
                            "-",
                          )}/`}
                          css={{ textDecoration: `none` }}
                        >
                          <Tag>{frontmatter.tags[0]}</Tag>
                        </Link>
                      )}

                      <Title>{frontmatter.title}</Title>

                      {frontmatter.image && (
                        <Img
                          fluid={frontmatter.image.childImageSharp.fluid}
                          css={{
                            marginBottom: `2rem`,
                            "@media only screen and (max-width: 600px)": {
                              marginLeft: `calc(50% - 49.99vw)`,
                              marginRight: `calc(50% - 49.99vw)`,
                              marginBottom: `1em`,
                            },
                          }}
                          alt={frontmatter.title}
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col span={{ xs: 12 / 12, lg: 69 / 100 }}>
                    {/* Breadcrumbs for interventions */}
                    {frontmatter.tags[0] !== "practice" &&
                      frontmatter.tags[0] !== "news" && (
                        <Breadcrumb>
                          <BreadcrumbItem>
                            <Link
                              to="/en/"
                              {...cssBreadcrumbLink}
                              title="Homepage"
                            >
                              <FaHome
                                css={{
                                  fontSize: `1.2em`,
                                  paddingBottom: `.2em`,
                                  transform: `translateY(5px)`,
                                }}
                              />
                            </Link>
                          </BreadcrumbItem>
                          <BreadcrumbItem>
                            <Link
                              {...cssBreadcrumbLink}
                              to={`/en/${frontmatter.tags[0].replace(
                                /\s+/g,
                                "-",
                              )}/`}
                            >
                              {frontmatter.tags[0].charAt(0).toUpperCase() +
                                frontmatter.tags[0].slice(1)}
                            </Link>
                          </BreadcrumbItem>
                          <BreadcrumbItem>{frontmatter.title}</BreadcrumbItem>
                        </Breadcrumb>
                      )}
                    {/* Breadcrumbs for actualites */}
                    {frontmatter.tags[0] === "news" && (
                      <Breadcrumb>
                        <BreadcrumbItem>
                          <Link
                            to="/en/"
                            {...cssBreadcrumbLink}
                            title="Homepage"
                          >
                            <FaHome
                              css={{
                                fontSize: `1.2em`,
                                paddingBottom: `.2em`,
                                transform: `translateY(5px)`,
                              }}
                            />
                          </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                          <Link to="/en/news/" {...cssBreadcrumbLink}>
                            news
                          </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>{frontmatter.title}</BreadcrumbItem>
                      </Breadcrumb>
                    )}
                    {/* Breadcrumbs for cabinet */}
                    {frontmatter.tags[0] === "practice" && (
                      <Breadcrumb>
                        <BreadcrumbItem>
                          <Link
                            to="/en/"
                            {...cssBreadcrumbLink}
                            title="Homepage"
                          >
                            <FaHome
                              css={{
                                fontSize: `1.2em`,
                                paddingBottom: `.2em`,
                                transform: `translateY(5px)`,
                              }}
                            />
                          </Link>
                        </BreadcrumbItem>

                        <BreadcrumbItem>{frontmatter.title}</BreadcrumbItem>
                      </Breadcrumb>
                    )}
                    <div
                      className="page-content"
                      dangerouslySetInnerHTML={{ __html: html }}
                    />
                    <TranslationBlock>
                      <p>
                        <span
                          role="img"
                          aria-label="English flag - drapeau anglais"
                        >
                          🇬🇧
                        </span>
                        <b>About the translation:</b> Parts of the English
                        version of this website were translated using computer
                        generated translation. If you notice a significant error
                        or if you have any doubt regarding the medical
                        information provided,{" "}
                        <Link to="/en/contact-us/">
                          please send us a message
                        </Link>
                        .
                      </p>
                    </TranslationBlock>
                    <Social path={frontmatter.path} title={frontmatter.title} />
                    {frontmatter.tags[0] !== "practice" && (
                      <Tags>
                        <div
                          css={{
                            fontSize: `0.85em`,
                            fontWeight: `600`,
                            textTransform: `uppercase`,
                            display: `inline-block`,
                            paddingRight: `5px`,
                          }}
                        >
                          Tags:
                        </div>
                        {frontmatter.tags.map((tag) => (
                          <Link
                            to={`/en/${tag.replace(/\s+/g, "-")}/`}
                            css={{
                              textDecoration: `none`,
                              fontSize: `.85em`,
                              color: `#3c4d68`,
                              fontWeight: `500`,
                            }}
                            className="tagsitem"
                          >
                            <TagsItem>{tag}</TagsItem>
                          </Link>
                        ))}
                      </Tags>
                    )}
                    <Bio />
                  </Col>
                  <Col span={{ xs: 12 / 12, lg: 31 / 100 }}>
                    <aside>
                      <ContactSidebar about={frontmatter.about} />
                      <AdresseSidebar />
                      <Accordion />
                      <AvantApresBlock />
                      <KeybodyBlock />
                      <VideoBlock />
                      <NewsBlock />
                      <ASavoir />
                    </aside>
                  </Col>
                </Row>
              </Container>
            </article>
          </Wrapper>
        )}

        {frontmatter.pageTemplate === "fullwidth" && (
          <div>
            <WrapperV2 className="full-width-page">
              <article
                data-pagefind-body
                data-pagefind-weight={
                ["cabinet", "practice"].includes(frontmatter.tags[0])
                  ? "2.5"
                  : "5"
              }
              >
                {frontmatter.image && (
                  <Img
                    fluid={frontmatter.image.childImageSharp.fluid}
                    css={{
                      marginBottom: `2rem`,
                      borderRadius: `25px 25px 0 0`,
                      "@media only screen and (max-width: 768px)": {
                        marginLeft: `calc(50% - 49.99vw)`,
                        marginRight: `calc(50% - 49.99vw)`,
                        marginBottom: `1em`,
                        borderRadius: `0`,
                      },
                    }}
                    alt={frontmatter.title}
                  />
                )}

                <Content>
                  {/* Breadcrumbs for interventions */}
                  {frontmatter.tags[0] !== "cabinet" &&
                    frontmatter.tags[0] !== "actualites" && (
                      <BreadcrumbV2>
                        <BreadcrumbItem>
                          <Link to="/en/" {...cssBreadcrumbLink} title="Home">
                            Home
                          </Link>
                        </BreadcrumbItem>

                        <BreadcrumbItem>
                          <Link
                            {...cssBreadcrumbLink}
                            to={`/en/${frontmatter.tags[0].replace(
                              /\s+/g,
                              "-",
                            )}/`}
                          >
                            {frontmatter.tags[0].charAt(0).toUpperCase() +
                              frontmatter.tags[0].slice(1)}
                          </Link>
                        </BreadcrumbItem>
                      </BreadcrumbV2>
                    )}
                  {/* Breadcrumbs for actualites */}
                  {frontmatter.tags[0] === "actualites" && (
                    <Breadcrumb>
                      <BreadcrumbItem>
                        <Link
                          to="/"
                          {...cssBreadcrumbLink}
                          title="Page d'accueil"
                        >
                          <FaHome
                            css={{
                              fontSize: `1.2em`,
                              paddingBottom: `.2em`,
                              transform: `translateY(5px)`,
                            }}
                          />
                        </Link>
                      </BreadcrumbItem>
                      <BreadcrumbItem>
                        <Link to="/actualites/" {...cssBreadcrumbLink}>
                          Actualites
                        </Link>
                      </BreadcrumbItem>
                      <BreadcrumbItem>{frontmatter.title}</BreadcrumbItem>
                    </Breadcrumb>
                  )}
                  {/* Breadcrumbs for cabinet */}
                  {frontmatter.tags[0] === "cabinet" && (
                    <Breadcrumb>
                      <BreadcrumbItem>
                        <Link
                          to="/"
                          {...cssBreadcrumbLink}
                          title="Page d'accueil"
                        >
                          <FaHome
                            css={{
                              fontSize: `1.2em`,
                              paddingBottom: `.2em`,
                              transform: `translateY(5px)`,
                            }}
                          />
                        </Link>
                      </BreadcrumbItem>

                      <BreadcrumbItem>{frontmatter.title}</BreadcrumbItem>
                    </Breadcrumb>
                  )}
                  <TitleV2>{frontmatter.title}</TitleV2>
                  <div
                    className="page-content"
                    dangerouslySetInnerHTML={{ __html: html }}
                  />
                </Content>

                <Social path={frontmatter.path} title={frontmatter.title} />
                {frontmatter.tags[0] !== "cabinet" && (
                  <Tags>
                    <div
                      css={{
                        fontSize: `0.85em`,
                        fontWeight: `600`,
                        textTransform: `uppercase`,
                        display: `inline-block`,
                        paddingRight: `5px`,
                      }}
                    >
                      Tags&nbsp;:
                    </div>
                    {frontmatter.tags.map((tag) => (
                      <Link
                        key={tag}
                        to={`/en/${tag.replace(/\s+/g, "-")}/`}
                        css={{
                          textDecoration: `none`,
                          fontSize: `.85em`,
                          color: `#3c4d68`,
                          fontWeight: `500`,
                        }}
                        className="tagsitem"
                      >
                        <TagsItem>{tag}</TagsItem>
                      </Link>
                    ))}
                  </Tags>
                )}
              </article>
              <TranslationBlockV2>
                <p>
                  <span role="img" aria-label="English flag - drapeau anglais">
                    🇬🇧
                  </span>
                  <b>About the translation:</b> Parts of the English version of
                  this website were translated using computer generated
                  translation. If you notice a significant error or if you have
                  any doubt regarding the medical information provided,{" "}
                  <Link to="/en/contact-us/">please send us a message</Link>.
                </p>
              </TranslationBlockV2>
            </WrapperV2>

            <BioWrapper>
              <BioV2 />
              <ContactSidebar about={frontmatter.about} />
            </BioWrapper>

            <BioWrapperMobile>
              <BioV2 className="mobile-only" />
              <p>&nbsp;</p>
              <ContactSidebar
                about={frontmatter.about}
                className="mobile-only"
              />
              <p>&nbsp;</p>
            </BioWrapperMobile>
          </div>
        )}

        <Footer />
      </g.Div>
    </Layout>
  );
}

export const pageQuery = graphql`
  query BlogPostByPathEn($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        pathFr
        title
        tags
        about
        pageTemplate
        metaTitle
        metaDescription
        image {
          absolutePath
          childImageSharp {
            resize(width: 1500, height: 1500) {
              src
            }
            fluid(maxWidth: 952) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`;
